import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';

import { Site} from '../../common/services';

@Component({
  selector: 'p8-bdc-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss']
})
export class HeroComponent implements OnInit, OnDestroy {
  @Input() site: Site;

  constructor() {

  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
  }

}
